import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import { isMobile } from '../utilities/breakpoints';
const { processAlertMessage } = require('../accessibility/accessibilityHelper');

const pdpPrimaryImages = {
    elements: {
        $document: $(document),
    },

    selectors: {
        carousel: '#pdp-primary-images',
    },

    settings: {
        carouselParameters:
        {
            modules: [Navigation, Pagination],
            slidesPerView: 1,
            loop: false,
            mousewheel: true,
            keyboard: true,
            navigation: {
                nextEl: ".js-pdp-primary-images-btn-next",
                prevEl: ".js-pdp-primary-images-btn-prev",
            },
            pagination: {
                el: ".js-pdp-primary-images-pagination",
                clickable: true,
            },
            on: {
                slideChangeTransitionEnd(swiper) {
                    processAlertMessage('Showing pdp primary images slide ' + (swiper.realIndex + 1), true);
                }
            }
        }
    },

    init() {
        if (isMobile()) {
            this.initCarousel();
        }
    },

    initCarousel() {
        new Swiper(this.selectors.carousel, this.settings.carouselParameters);
    }
};

pdpPrimaryImages.init();

